import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import MainView from './pages/MainView';
import MonthlyView from './pages/MonthlyView';

// Create router - simplified for offline use
const router = createBrowserRouter([
  {
    path: "/",
    element: <MainView />
  },
  {
    path: "/monthly/:habitId",
    element: <MonthlyView />
  },
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);

export const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />;
};